import React, { useState, useEffect, useRef } from 'react'
import { css } from 'emotion';
import PropTypes from 'prop-types'
import flatpickr from 'flatpickr'
import moment from 'moment'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { flatpickrStyle, defaultStyle } from './style'
import { Input } from '@maxmilhas/hangar-components-atomic/public'

export const DatePicker = ({
  id, name,label, placeholder, icon, hasError, defaultDate,
  minDate, maxDate, onOpen, onClose, onChange, ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const input = useRef(null);
  let instance = null;

  useEffect(() => {
    const { inputElement } = input.current;

    instance = flatpickr(inputElement, {
      defaultDate,
      minDate,
      maxDate,
      appendTo: inputElement.parentElement,
      locale: Portuguese,
      monthSelectorType: 'static',
      dateFormat: 'd/m/Y',
      ariaDateFormat: 'F, j Y',
      disableMobile: true,
      allowInput: true,
      static: true,
      onChange: (selectedDates) => {
        onChange(selectedDates[0]);
      },
      onOpen: (selectedDates, dateStr, instance) => {
        document.addEventListener('keydown', handleCloseOnTab)
        let min = instance.config.minDate || moment.utc().startOf('day').toDate()
        if (selectedDates.length > 0) {
          min = selectedDates[0]
        }
        instance.jumpToDate(min, true)
        onOpen && onOpen(selectedDates.length > 0 ? selectedDates[0] : null)
        setIsOpen(true);
      },
      onClose: (selectedDates, dateStr, instance) => {
        document.removeEventListener('keydown', handleCloseOnTab)
        if (instance.input.value.length === 0 && instance.latestSelectedDateObj) {
          instance.setDate(instance.latestSelectedDateObj, true)
        }
        onClose && onClose(selectedDates.length > 0 ? selectedDates[0] : null)
        setIsOpen(false);
      }
    })
  }, []);

  const handleCloseOnTab = event => {
    if (event.keyCode === 9) {
      instance.close();
    }
  }

  const handleChangeInput = (event) => {
    const currentValue = event.target.value.replace(/[^\d/]/g, '');

    if (currentValue.length === 10) {
      if (moment(currentValue, 'DD/MM/YYYY').isValid()) {
        instance.setDate(currentValue, true);
      } else {
        instance.setDate(instance.latestSelectedDateObj, true);
      }
    }
  };

  return (
    <div className={css`${theme => `${flatpickrStyle}; ${defaultStyle(theme, isOpen, hasError)}`}`}>
      <Input
        ref={input}
        id={id}
        name={name}
        label={label}
        placeholder={placeholder}
        icon={icon}
        onChange={handleChangeInput}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        hasError={hasError}
        {...rest}
      />
    </div>
  );
};

DatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  hasError: PropTypes.bool,
  defaultDate: PropTypes.object,
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onChange: PropTypes.func
}

DatePicker.defaultProps = {
  name: null,
  label: null,
  placeholder: null,
  icon: null,
  hasError: false,
  defaultDate: null,
  minDate: null,
  maxDate: null,
  onOpen: null,
  onClose: null,
  onChange: () => undefined
}

export default DatePicker;
